<template>
  <li class="side-menu-list__item" v-if="this.$route.path != '/'">
    <a href="#" class="side-menu-list__icon icon-search" :class="icon" v-on:click.prevent="toggle"></a>
    <div class="sidebar" v-if="active">
      <div class="sidebar__block">
        <p class="sidebar__title">{{getResource('Search')}}</p>
        <input class="input input--side_search" placeholder="{{getResource('Search')}}" v-model="searchString"/>
        <select class="select select--side_search" v-model="fileTypeId">
          <option :value="term.Value" v-for="term in searchTerms">{{term.Text}}</option>
        </select>
        <button class="button" @click="search()" :disabled="!searchString.length">{{getResource('Search')}}</button> 
      </div>
    </div>
    <div v-if="active" class="side-menu-closer" v-on:click.prevent="toggle">
    </div>
  </li>
</template>
<script>
  import { getResource } from "../../../vuex/helpers";

  export default {
    data: function () {
      return {
        fileTypeId: -1,
        searchString: ""
      };
    },
    vuex: {
      getters: {
        menuItem: state => state.menuItem,
        searchTerms: state => state.searchTerms,
        sidebarActive: state => state.sidebarActive
      },
      actions: {
        getResource
      }
    },
    computed: {
      active () {
        return this.menuItem === this._uid;
      },
      icon () {
        return (this.sidebarActive && !this.active) ? " icon--disabled" : "";
      }
    },
    methods: {
      toggle () {
        this.$dispatch("submenu_clicked", this._uid, true);
      },
      search () {
        this.toggle();
        this.$router.go("/search/" + this.fileTypeId + "/" + this.searchString);
      }
    }
  };
</script>
<style lang="scss">
  @import '../../../assets/scss/variables.scss';
  @import '../../../assets/scss/mixins.scss';

  .input.input--side_search {
    width:100%;
    margin-bottom: 15px;
    border: 1px solid $green_dark;
    
  }
  .select--side_search{
    width: 100%;
    margin-bottom: 40px;
  }
  
</style>



// WEBPACK FOOTER //
// SidebarSearch.vue?7078467a